<template>
    <span>
        <button @click="openSubscribeDialog" class="cursor-pointer" aria-label="Subscribe to Interruptions">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/>
                <polygon points="22 2 15 22 11 13 2 9 22 2"/>
            </svg>
        </button>
        <subscribe-modal
            ref="subscribeModal"
            :location="location"
            :location-name="locationName"
            :host="host"
            :host-name="hostName"
            :interruption="interruption"
            :interruption-name="interruptionName"
            :zap-service="zapService"
            :zap-service-name="zapServiceName"
            :lookup="lookup"
            :lookup-name="lookupName"
        ></subscribe-modal>
    </span>
</template>

<script>
export default {
    props: {
        location: {
            required: false,
            type: String
        },
        locationName: {
            required: false,
            type: String
        },
        host: {
            required: false,
            type: String
        },
        hostName: {
            required: false,
            type: String
        },
        interruption: {
            required: false,
            type: String
        },
        interruptionName: {
            required: false,
            type: String
        },
        zapService: {
            required: false,
            type: String
        },
        zapServiceName: {
            required: false,
            type: String
        },
        lookup: {
            required: false,
            type: String
        },
        lookupName: {
            required: false,
            type: String
        },
    },
    data() {
        return {
            subscribeModalOpen: false,
        }
    },
    methods: {
        openSubscribeDialog() {
            this.$refs.subscribeModal.openSubscribeDialog();
        },
    }
}
</script>
